import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {intlShape, FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import _ from 'lodash';

const LOCALE_PREFIX = 'DE/pages/SepaPage/SepaPage';

export class UserInfoDisplay extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        givenName: PropTypes.string.isRequired,
        familyName: PropTypes.string.isRequired,
        street1: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        countryName: PropTypes.string,
        postalCode: PropTypes.string.isRequired
    };

    render() {
        const { givenName, familyName, street1, city, countryName, postalCode} = this.props;
        return (
            <div>
                <h4>
                    <FormattedMessage id={`${LOCALE_PREFIX}.accountCarrier`} />
                </h4>
                <div id="sepa-owner">
                    <span>{givenName} {familyName}</span>
                    <div id="sepa-street1">
                        <span>{street1}</span>
                        <div id="sepa-country">
                            <span> {postalCode} {city} {countryName}</span>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export const mapStateToProps = state => ({
    familyName: _.get(state, 'serverData.decisionModel.owner.familyName'),
    givenName: _.get(state, 'serverData.decisionModel.owner.givenName'),
    street1: _.get(state, 'serverData.decisionModel.owner.billingAddress.street1'),
    city: _.get(state, 'serverData.decisionModel.owner.billingAddress.city'),
    countryName: _.get(state, 'serverData.decisionModel.owner.billingAddress.countryName'),
    postalCode: _.get(state, 'serverData.decisionModel.owner.billingAddress.postalCode')
});

export default connect(mapStateToProps)(injectIntl(UserInfoDisplay));
